module.exports = __webpack_public_path__ + "img/04.3ad90ee3.jpg";